import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE = "https://nexusnumbers.com";

function upsertName(name, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertProp(prop, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, obj) {
  let el = document.getElementById(id);
  if (obj == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.setAttribute("data-testid", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export const Seo = ({
  title,
  description,
  canonicalPath,
  robots = "index, follow",
  ogType = "website",
  image = `${SITE}/nexus-og.jpg`,
  jsonLd,
}) => {
  const loc = useLocation();
  useEffect(() => {
    const canonical = SITE + (canonicalPath || loc.pathname);
    document.title = title;
    upsertName("description", description);
    upsertName("robots", robots);
    upsertCanonical(canonical);
    upsertProp("og:site_name", "Nexus Numbers Paystub Generator");
    upsertProp("og:title", title);
    upsertProp("og:description", description);
    upsertProp("og:type", ogType);
    upsertProp("og:url", canonical);
    upsertProp("og:image", image);
    upsertName("twitter:card", "summary_large_image");
    upsertName("twitter:title", title);
    upsertName("twitter:description", description);
    upsertName("twitter:image", image);
    upsertJsonLd("page-jsonld", jsonLd || null);
    return () => upsertJsonLd("page-jsonld", null);
  }, [title, description, canonicalPath, robots, ogType, image, jsonLd, loc.pathname]);
  return null;
};
